import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="confirmation"
export default class extends Controller {
  static values = {
    message: String,
  }

  declare readonly messageValue: string

  confirm (event: Event): void {
    if (!(window.confirm(this.messageValue))) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
